// 听书
const xmlyRoutes = Array.from({ length: 9 }, (_, i) => ({
  path: `hear/xmly/index${i + 1}`,
  name: `hear/xmly/Index${i + 1}`,
  component: () => import(`@/views/entertainment/hear/xmly/index${i + 1}.vue`)
}))
const branch1xmlyhRoutes = Array.from({ length: 9 }, (_, i) => ({
  path: `hear/xmly/branch1/index${i + 1}`,
  name: `hear/xmly/branch1/Index${i + 1}`,
  component: () => import(`@/views/entertainment/hear/xmly/branch1/index${i + 1}.vue`)
}))
const branch2xmlyRoutes = Array.from({ length: 15 }, (_, i) => ({
  path: `hear/xmly/branch2/index${i + 1}`,
  name: `hear/xmly/branch2/Index${i + 1}`,
  component: () => import(`@/views/entertainment/hear/xmly/branch2/index${i + 1}.vue`)
}))
const branch3xmlyRoutes = Array.from({ length: 12 }, (_, i) => ({
  path: `hear/xmly/branch3/index${i + 1}`,
  name: `hear/xmly/branch3/Index${i + 1}`,
  component: () => import(`@/views/entertainment/hear/xmly/branch3/index${i + 1}.vue`)
}))

const ytRoutes = Array.from({ length: 13 }, (_, i) => ({
  path: `hear/yt/index${i + 1}`,
  name: `hear/yt/Index${i + 1}`,
  component: () => import(`@/views/entertainment/hear/yt/index${i + 1}.vue`)
}))
const branch1ytRoutes = Array.from({ length: 9 }, (_, i) => ({
  path: `hear/yt/branch1/index${i + 1}`,
  name: `hear/yt/branch1/Index${i + 1}`,
  component: () => import(`@/views/entertainment/hear/yt/branch1/index${i + 1}.vue`)
}))
const branch2ytRoutes = Array.from({ length: 20 }, (_, i) => ({
  path: `hear/yt/branch2/index${i + 1}`,
  name: `hear/yt/branch2/Index${i + 1}`,
  component: () => import(`@/views/entertainment/hear/yt/branch2/index${i + 1}.vue`)
}))
const branch3ytRoutes = Array.from({ length: 6 }, (_, i) => ({
  path: `hear/yt/branch3/index${i + 1}`,
  name: `hear/yt/branch3/Index${i + 1}`,
  component: () => import(`@/views/entertainment/hear/yt/branch3/index${i + 1}.vue`)
}))
const branch4ytRoutes = Array.from({ length: 5 }, (_, i) => ({
  path: `hear/yt/branch4/index${i + 1}`,
  name: `hear/yt/branch4/Index${i + 1}`,
  component: () => import(`@/views/entertainment/hear/yt/branch4/index${i + 1}.vue`)
}))



import hearIndex from '@/views/entertainment/hear/index'



export default {
  path: '/entertainment',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
      {
        path: 'hear/index',
        name: 'hearIndex',
        component: hearIndex
      },
    // 听书，开始
    ...xmlyRoutes,
    ...branch1xmlyhRoutes,
    ...branch2xmlyRoutes,
    ...branch3xmlyRoutes,
    ...ytRoutes,
    ...branch1ytRoutes,
    ...branch2ytRoutes,
    ...branch3ytRoutes,
    ...branch4ytRoutes,






    // 听书，结束


  ],
};
